import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forward-link',
  templateUrl: './forward-link.component.html',
  styleUrls: ['./forward-link.component.scss']
})
export class ForwardLinkComponent implements OnInit {

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    var link = this.route.snapshot.queryParamMap.get('link');
    window.open(link, '_self');
  }

}
